module.exports = __webpack_public_path__ + "img/Feature-3.1848c8b.svg";